import Vue from 'vue';

export default {
    // COMMON

    setTaggingMode(state, isTagging) {
        state.isTagging = isTagging;
    },
    setLoadingState(state, isLoading) {
        state.isLoading = isLoading;
    },
    setCaseId(state, caseId) {
        state.chatData.caseId = caseId;
    },
    setTaggingMessageId(state, messageId) {
        state.chatData.taggingMessageId = messageId;
    },
    setSearchMessageId(state, messageId) {
        state.chatData.searchMessageId = messageId;
    },
    clearSearchMessageId(state) {
        state.chatData.searchMessageId = null;
    },
    setChatData(state, chatData) {
        state.chatData = chatData;
    },
    setChatId(state, chatId) {
        state.chatData.chatId = chatId;
    },
    setCurrentRoute(state, currentRoute) {
        state.currentRoute = currentRoute;
    },
    setKeySearch(state, keySearch) {
        state.keySearch = keySearch;
    },
    setHasMoreMessages(state, hasMoreMessages) {
        state.hasMoreMessages = hasMoreMessages;
    },
    setMessages(state, messages) {
        state.messages = messages;
    },

    // REMINDERS

    setCountReminders(state, countReminders) {
        state.countReminders = countReminders;
    },
    setReminder(state, remindAt) {
        state.remindAt = remindAt;
    },


    // TAGS

    setMessageTags(state, messageTags) {
        state.messageTags = messageTags;
    },
    setChatTags(state, chatTags) {
        state.chatTags = chatTags;
    },

    // MESSAGE

    setTaggingMessage(state, taggingMessage) {
        state.taggingMessage = taggingMessage;
    },
    setUnBlurredMessage(state, unBlurredMessage) {
        state.unBlurredMessage = unBlurredMessage;
    },
    setEditingComment(state, comment) {
        state.editingComment = comment;
    },
    setComments(state, comments) {
        state.comments = comments;
    },


    // UTILS

    UPDATE_COMMENT(state, {index, updatedComment}) {
        Vue.set(state.messages, index, updatedComment);
    },

    resetTabState(state) {
        state.chatPage = 1;
        state.messages = [];
        state.keySearch = '';
    },

    resetState(state) {
        // state.chatId = null;
        // state.caseId = null;
        state.isTagging = false;
        state.isLoading = false;
        state.hasMoreMessages = false;
        state.chatPage = 1;
        state.keySearch = '';

        state.editingMessage = null;
        state.editingComment = null;
        state.unBlurredMessage = null;

        state.comments = [];
        state.chatTags = [];
        state.messageTags = [];

        state.messages = [];
        state.tagsTabMessages = [];

        state.currentRoute = '';

        state.reminderMessages = [];
        state.countReminders = 0;
        state.remindAt = new Date();

        // Clear search message ID
        state.chatData.searchMessageId = null;
    }
};
